import React from 'react';
import {Link}  from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

interface CompanyStateBarProps{
    selected: string;
    countScheduled: number;
}

const CompanyStateBar: React.FC<CompanyStateBarProps> = ({selected, countScheduled})=>{

  const buttons = [
    {id: 1, name: 'Gestión de estados', state: 'Gestion', url: "/admin/dashboard/empresas"},
    {id: 2, name: 'Mensajería masiva', state: 'Mensajeria', url: "/admin/dashboard/mensajeria-empresas"},
    {id: 3, name: 'Mensajería programada', state: 'Programada', url: "/admin/dashboard/mensajeria-programada/company"},
    {id: 4, name: 'Reportes empresas', state: 'Reportes', url: "/admin/dashboard/reportes-empresas"},
    {id: 5, name: 'Reportes ofertas', state: 'Ofertas', url: "/admin/dashboard/reportes-ofertas"},
  ]

  return (
    <Grid item xs={12} className="state-bar-container">
      <Grid container item xs={12} className="container-buttons">
        {buttons.map(item=>(
          <Link key={item.id}  to={item.url} className="link-state-bar">
            <div className={selected === item.state ? 'button-definition-active' : 'button-definition'}>
              <Typography variant="h5" className="regular-serif">
                {item.name}
              </Typography>
              {(countScheduled > 0 && item.id === 3) &&
                <Typography variant="h6" className="button-number-active" style={{ marginLeft: "8px" }}>
                  {countScheduled}
                </Typography>
              }              
            </div>
          </Link>
        ))}
      </Grid>
    </Grid>
  )
}

export default CompanyStateBar;
